module.exports = __webpack_public_path__ + "static/media/SYUKO2022Logo.aac1bed9.svg";